import { Outlet } from 'react-router-dom'
import styles from './AuthWrapper.module.scss'

export const AuthWrapper: React.FC = () => {
  return (
    <main className={styles.wrapper}>
      <Outlet />
    </main>
  )
}